exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-headers-wrapper{position:absolute;inset-inline-start:0;inset-inline-end:0;inset-block-end:0;pointer-events:none;z-index:73}.BottomHeader{display:inline-block;width:100%;pointer-events:auto}.BottomHeader.SpreadsheetSwitcher{display:block}.BottomHeader.closed{display:none}.BottomHeader.stroke{border-top:1px solid var(--gray-5)}", ""]);

// exports
